var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7143 4.07566C11.8608 3.92921 12.0982 3.92921 12.2447 4.07566L18.7295 10.5605V20.3749C18.7295 20.582 18.5616 20.7499 18.3545 20.7499H16.4795H14.9795V16.6249C14.9795 15.5893 14.14 14.7499 13.1045 14.7499H10.8545C9.81896 14.7499 8.97949 15.5893 8.97949 16.6249V20.7499H8.22949H5.60449C5.39739 20.7499 5.22949 20.582 5.22949 20.3749V10.5605L11.7143 4.07566L11.184 3.54533L11.7143 4.07566ZM3.72949 12.0605L2.75982 13.0302C2.46693 13.3231 1.99206 13.3231 1.69916 13.0302C1.40627 12.7373 1.40627 12.2624 1.69916 11.9695L10.6537 3.015C11.3859 2.28276 12.5731 2.28276 13.3053 3.01499L22.2598 11.9695C22.5527 12.2624 22.5527 12.7373 22.2598 13.0302C21.9669 13.3231 21.4921 13.3231 21.1992 13.0302L20.2295 12.0605V20.3749C20.2295 21.4104 19.39 22.2499 18.3545 22.2499H16.4795H14.2295H9.72949H8.22949H5.60449C4.56896 22.2499 3.72949 21.4104 3.72949 20.3749V12.0605ZM13.4795 20.7499H10.4795V16.6249C10.4795 16.4178 10.6474 16.2499 10.8545 16.2499H13.1045C13.3116 16.2499 13.4795 16.4178 13.4795 16.6249V20.7499Z",
    fill: "#B0B3BC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d864765c62123f7f6eaf3d486c4f6fc4.svg";
export { ForwardRef as ReactComponent };